import { ManualSystemChargeEntity } from "domain/entity/ChargeDataEnquiry/ManualSystemChargeEntity";
import { EMPTY_TRANSFER_OF_CHARGE_SEARCH_CRITERIA } from "domain/entity/TransferOfCharge/TransferOfChargeSearchCriteria";
import { customEventListener, E_Custom_Dispatch_Event, E_Type_Of_Event } from "helpers/Events";
import { useTransferOfChargeVM } from "presentation/hook/TransferOfCharge/useTransferOfChargeVM";
import { useTransferOfChargeTracked } from "presentation/store/TransferOfCharge/TransferOfChargeProvider";
import { memo, useCallback, useEffect, useRef, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import TransferOfChargeRightPanel from "./TransferOfChargeRightPanel";
import TransferOfChargeSearchPanel from "./TransferOfChargeSearchPanel";
import TransferOfChargeTitleBar from "./TransferOfChargeTitleBar";

const TransferOfChargeMaintenance: React.FC = () => {
    const [transferOfChargeState] = useTransferOfChargeTracked();
    const transferOfChargeVM = useTransferOfChargeVM();
    const [isLoading, setIsLoading] = useState(true);
    const { isShowSearchPanel } = transferOfChargeState;
    const [initial, setInitial] = useState<boolean>(false);

    const hasInitializedRef = useRef<boolean>(false);

    const initialScreen = useCallback(async () => {
        try {
            setIsLoading(true);
            await Promise.allSettled([
                transferOfChargeVM.loadDropdownOption(),
            ]);
            setInitial(false);
            hasInitializedRef.current = true;
        } catch (error) {
            setIsLoading(false);
            hasInitializedRef.current = true;
        }
    }, [transferOfChargeVM]);


    const initialRedirectScreen = useCallback(async () => {
        const manSysCharge = localStorage.getItem(E_Custom_Dispatch_Event.REDIRECT_TOC_CHARGE_DETAIL_FROM_CHARGE_ITEM_SEARCH) ?
            JSON.parse(localStorage.getItem(E_Custom_Dispatch_Event.REDIRECT_TOC_CHARGE_DETAIL_FROM_CHARGE_ITEM_SEARCH) ?? "") as ManualSystemChargeEntity :
            null;
        if (!manSysCharge) return;

        await Promise.allSettled([
            transferOfChargeVM.loadDropdownOption(),
            transferOfChargeVM.onSearch({
                ...EMPTY_TRANSFER_OF_CHARGE_SEARCH_CRITERIA,
                cntrNos: [manSysCharge.cntrNo ?? ''],
                blNo1: manSysCharge.blNo1 ?? '',
                soNumber1: manSysCharge.soNumber1 ?? ''
            }).finally(() => {
                localStorage.removeItem(E_Custom_Dispatch_Event.REDIRECT_TOC_CHARGE_DETAIL_FROM_CHARGE_ITEM_SEARCH);
                setInitial(false);
                setIsLoading(false);
                hasInitializedRef.current = true;
            }),
        ]).catch(error => {
            setInitial(false);
            setIsLoading(false);
            localStorage.removeItem(E_Custom_Dispatch_Event.REDIRECT_TOC_CHARGE_DETAIL_FROM_CHARGE_ITEM_SEARCH);
            hasInitializedRef.current = true;
        });


    }, [transferOfChargeVM])

    useEffect(() => {
        const onChargeDetailRedirect = async (e: any) => {
            switch (e.detail.action) {
                case E_Custom_Dispatch_Event.REDIRECT_TOC_CHARGE_DETAIL_FROM_CHARGE_ITEM_SEARCH:
                    const manSysCharge = (e.detail.data.data as ManualSystemChargeEntity);
                    localStorage.setItem(E_Custom_Dispatch_Event.REDIRECT_TOC_CHARGE_DETAIL_FROM_CHARGE_ITEM_SEARCH, JSON.stringify(manSysCharge));
                    setInitial(true);
                    hasInitializedRef.current = false;

                    break;
            }
        }

        customEventListener(E_Type_Of_Event.TOC_CHARGE_DETAIL_REDIRECT_EVENT_INITIAL, onChargeDetailRedirect);
    }, []);

    useEffect(() => {
        const manSysCharge = localStorage.getItem(E_Custom_Dispatch_Event.REDIRECT_TOC_CHARGE_DETAIL_FROM_CHARGE_ITEM_SEARCH) ?
            JSON.parse(localStorage.getItem(E_Custom_Dispatch_Event.REDIRECT_TOC_CHARGE_DETAIL_FROM_CHARGE_ITEM_SEARCH) ?? "") as ManualSystemChargeEntity :
            null;

        if (hasInitializedRef.current) return;
        if (!manSysCharge) {
            transferOfChargeVM.setIsSearchLoading(true);
            initialScreen().then((data) => {
                setIsLoading(false);
                transferOfChargeVM.setIsSearchLoading(false);
            }).catch(error => {
                setIsLoading(false);
                transferOfChargeVM.setIsSearchLoading(false);
            });
        } else {
            transferOfChargeVM.setIsSearchLoading(true);
            setIsLoading(true);
            initialRedirectScreen().then((data) => {
                setIsLoading(false);
                transferOfChargeVM.setIsSearchLoading(false);
            }).catch(error => {
                setIsLoading(false);
                transferOfChargeVM.setIsSearchLoading(false);
            });
        }
    }, [transferOfChargeVM, initial, initialRedirectScreen, initialScreen])

    // if (isLoading || initial) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper${isShowSearchPanel ? '' : ' im-hide-side-form-draggable'}`}>

            <TransferOfChargeTitleBar />
            {(isLoading) && <Loader Indicator="Stripe" size="Large" />}
            <SliderPanel
                isOpen={true}
                draggable={true}
                leftSectionWidth={isShowSearchPanel ? "30%" : "0%"}
                rightSectionWidth={isShowSearchPanel ? "70%" : "100%"}
                leftChildren={<TransferOfChargeSearchPanel />}
                rightChildren={<TransferOfChargeRightPanel />}
            />
        </div>
    </>
}

export default memo(TransferOfChargeMaintenance);